module.exports = __webpack_public_path__ + "static/media/94 - Khruangbin - Time (You and I).ac9b45a4.mp3";